import AOS from "aos"
import Alpine from 'alpinejs'
import { Alert } from 'bootstrap'

import DatetimeInputs from './components/datetime-inputs'
import Reservation from './components/reservation'
import Sliders from './components/sliders'
import Readmore from './components/readmore'
import HeaderMenu from "./components/header-menu"

window._ = require('lodash')
window.axios = require('axios')
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

window.Alpine = Alpine

const init = () => {
  Alpine.start()

  AOS.init({
    once: true,
  })
  
  DatetimeInputs.init()
  Reservation.init()
  Sliders.init()
  Readmore.init()
  HeaderMenu.init()
}

if(document.readyState == 'complete') {
  init()
} else {
  document.addEventListener('DOMContentLoaded', init)
}
